import ModalSendFinalPDF from './ModalSendFinalPDF-redux';

export default ModalSendFinalPDF;
